import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Star } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#2A1D1A] text-[#FAF8F5]">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
        <div className="grid grid-cols-1 gap-14 md:grid-cols-12">
          <div className="md:col-span-4">
            <p className="font-serif-display text-3xl font-medium leading-tight">
              Maison Désir <span className="italic text-[#CBA135]">&</span> Gourmandise
            </p>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-[#B8A99F]">
              Traiteur événementiel depuis 2012. Cocktails, buffets sur-mesure, plateaux-repas et
              animation brasero &amp; paella — à Lyon, Valence, Grenoble et dans toute la région
              Auvergne-Rhône-Alpes.
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.25em] text-[#CBA135]">Navigation</p>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                ["/", "Accueil"],
                ["/prestations", "Prestations"],
                ["/traiteur-lyon", "Traiteur Lyon"],
                ["/traiteur-valence", "Traiteur Valence"],
                ["/traiteur-grenoble", "Traiteur Grenoble"],
                ["/plateau-repas-entreprise-lyon", "Plateaux-repas Lyon"],
                ["/traiteur-drome", "Traiteur Drôme"],
                ["/traiteur-ardeche", "Traiteur Ardèche"],
                ["/traiteur-chambery", "Traiteur Chambéry"],
                ["/devis", "Devis"],
                ["/budget-traiteur", "Budget & prix"],
                ["/prix-traiteur-lyon", "Prix traiteur Lyon"],
                ["/realisations", "Nos réalisations"],
                ["/traiteur-50-personnes-lyon", "Traiteur 50 personnes Lyon"],
                ["/traiteur-100-personnes-lyon", "Traiteur 100 personnes Lyon"],
                ["/traiteur-seminaire-lyon", "Traiteur séminaire Lyon"],
                ["/traiteur-derniere-minute-lyon", "Traiteur dernière minute Lyon"],
                ["/traiteur-particuliers-lyon", "Traiteur particuliers Lyon"],
                ["/traiteur-halal-lyon", "Traiteur halal Lyon"],
                ["/traiteur-halal-valence", "Traiteur halal Valence"],
                ["/traiteur-halal-grenoble", "Traiteur halal Grenoble"],
                ["/traiteur-bapteme-lyon", "Traiteur baptême Lyon"],
                ["/traiteur-bapteme-valence", "Traiteur baptême Valence"],
                ["/traiteur-bapteme-grenoble", "Traiteur baptême Grenoble"],
                ["/traiteur-50-personnes-valence", "Traiteur 50 personnes Valence"],
                ["/traiteur-50-personnes-grenoble", "Traiteur 50 personnes Grenoble"],
                ["/menus-noel", "Menus de Noël"],
                ["/gouter-noel-entreprise", "Goûter Noël entreprise"],
                ["/blog", "Blog"],
                ["/contact", "Contact"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} data-testid={`footer-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-[#B8A99F] transition-colors hover:text-[#FAF8F5]">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-[#CBA135]">Nos spécialités</p>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                ["/brasero", "Brasero au feu de bois"],
                ["/paella", "Paella géante en live"],
                ["/pieces-cocktail", "Pièces cocktail"],
                ["/plateaux-repas", "Plateaux-repas entreprise"],
                ["/buffets", "Buffets sur-mesure"],
                ["/animations", "Animations culinaires"],
                ["/couscous", "Couscous géant"],
                ["/mariage", "Traiteur mariage"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} data-testid={`footer-specialite-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-[#B8A99F] transition-colors hover:text-[#FAF8F5]">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-[#CBA135]">Nous joindre</p>
            <ul className="mt-5 space-y-4 text-sm text-[#B8A99F]">
              <li className="flex items-start gap-3">
                <Phone size={16} className="mt-0.5 shrink-0 text-[#C05A45]" />
                <a href="tel:0484507142" data-testid="footer-phone" className="transition-colors hover:text-[#FAF8F5]">04 84 50 71 42 — 07 69 27 60 21</a>
              </li>
              <li className="flex items-start gap-3">
                <Star size={16} className="mt-0.5 shrink-0 text-[#CBA135]" />
                <a href="https://g.page/r/CV0dXkh-ba4dEBM/review" target="_blank" rel="noopener noreferrer" data-testid="footer-google-reviews" className="transition-colors hover:text-[#CBA135]">
                  ★ 4,9/5 — Laisser un avis Google
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 shrink-0 text-[#C05A45]" />
                <a href="mailto:devis@gourmandise-traiteur.fr" data-testid="footer-email" className="transition-colors hover:text-[#FAF8F5]">
                  devis@gourmandise-traiteur.fr
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 shrink-0 text-[#C05A45]" />
                <span>Parc du Chêne, 69500 Bron — Lyon<br />105 rue des Mourettes, 26000 Valence<br />Grenoble &amp; Isère — desservis depuis nos ateliers</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-[#3d2c26] pt-8 text-xs text-[#7A6B63] md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Maison Désir &amp; Gourmandise — Traiteur Lyon, Valence, Grenoble.</p>
          <p className="font-serif-display italic">L'art de recevoir, depuis 2012.</p>
        </div>
      </div>
    </footer>
  );
}
